export default __webpack_public_path__ + "static/media/data.09699ce7.jpg";